import React, { Component } from 'react'
import Layout from './../../wrapper'
import { connect } from 'react-redux'
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Maiclist } from '../../Components/MaicIntegration/index'
import { logInUserInfo } from '../../Actions/Users'

import { checkPrivileges } from '../../Helpers'
import withRoutes from '../../HOC/HocRoutes';

class MaicIntegration extends Component {
  constructor (props) {
    super(props)
    this.state = {
        isVisable: true,
        sessionCallTrack: true,
        unitsApiCall: true
    }
  }
  componentWillMount () {
    // this.props.dispatch(toast.removeAll())
  }
  controleSession = () => {
    if (localStorage.getItem('userInfo')) {
      fetch('/api/session', {
        method: 'DELETE'
      }).then(res => {
        let response = res.data
        if (response.ok) {
          this.props.navigate('/logout')
        }else{
          throw response
        }
      }).catch(e => {})
    }
  }
  render () {
    if (this.props.logInUser) {
    if (checkPrivileges('device')) {
    
        if (this.props.logInUser.userType === 6) {
          this.props.navigate('/*')
        } else {
          return (
            <Layout {...this.props}>
              <Maiclist {...this.props} />
            </Layout>
          )
        }
      
    } else if (
      !checkPrivileges('account') &&
      !checkPrivileges('user') &&
      !checkPrivileges('group')
    ) {
      this.controleSession()
      return null
    } else {
      return defaultPages.map(page => {
        if (checkPrivileges(page)) {
          this.props.navigate(`/${page}s`)
        }
        return null
      })
    }
  }
    else {
      if (this.state.sessionCallTrack) {
        this.setState(
          {
            sessionCallTrack: false
          },
          () => {
            fetch('/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05', {
              headers: { Accept: 'application/json; odata=verbose' }
            }).then(response => {
              if (response.ok) {
                response.json().then(res => {
                  if(res.status ==='success'){ 
                    let userInfo = res.data
                    this.props.setActiveLanguage(
                      userInfo?.attributes?.lang || 'en'
                    )
                    //API privilige call
                    if(res.status === 'success'){
                      fetch(`/api/privileges?roleId=${userInfo.roleId}`, {
                        method: 'Get'
                      })
                        .then(response => {
                          if (response.ok) {
                            response.json().then(res2 => {
                              if(res2.status ==='success'){ 
                                let privileges = res2.data
                                let privilegeKeys = []
                                privileges.map(item => {
                                  privilegeKeys.push(item.key)
                                })
                                localStorage.setItem(
                                  'privileges',
                                  JSON.stringify({ ...privilegeKeys })
                                )
                                if (privileges.length) {
                                  localStorage.setItem('userToken', '')
                                  this.props.navigate('/maic-integration')
                                } else {
                                  this.setState({
                                    loading: false,
                                    loginErrorMessage: 'lackOfPrivileges'
                                  })
                                }
                              }
                              else if(res?.statusCode === '440'){
                                window.location.replace('/login')
                              }
                              else if(res.statusCode){
                                var err = res?.message.split(':')
                                err[1] =err[1].replace(')', "")
                             
                                  toast.error(
                                     this.props.translate(err[1])
                                )
                              }
                            })
                            .catch(e => {
                               console.log('e =',e)
                              // this.props.dispatch(toast.error({
                              //   message: 'somethingWentWrong',
                              //   autoDismiss: 5
                              // }))
                            })
                          } 
                        })
                        .catch(e=>{
                        
                            toast.error(
                              this.props.translate('somethingWentWrong')
                          )
                        })
                    }
                     else if(res.statusCode){
                      var err = res.message.split(':')
                      err[1] =err[1].replace(')', "")
                  
                        toast.error(
                          this.props.translate(err[1])
                      )
                      this.props.navigate('/logout')
                    }
                      

                    //Privilige call ends

                    this.props.dispatch(logInUserInfo(userInfo))

                  }
                  else if(res?.statusCode === '440'){
                    window.location.replace('/login')
                  }
                  else if(res.statusCode){
                    var err = res?.message.split(':')
                    err[1] =err[1].replace(')', "")
                   
                      toast.error(
                        this.props.translate(err[1])
                    )
                    this.props.navigate('/logout')
                  }
                })
              } else {
                this.props.navigate('/logout')
                  throw response
                }
              }).catch(e => {
                toast.error(
                 'somethingWentWrong'
                )
              })
          }
        )
      }
      return null
    }
  }
}
const mapStateToProps = state => ({
    ServerSetting: state.ServerSetting,
    logInUser: state.logInUsers,
    users: state.users,
    roles: state.roles,
    devices: state.devices
  })
  
export default connect(mapStateToProps)(withRoutes(MaicIntegration))

const defaultPages = ['accounts', 'users', 'group']